import React, { useState, useEffect } from "react";
import api from "../api/axios";
import { useSearchParams, useNavigate } from "react-router-dom";

export default function ResetPassword() {
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  const token = searchParams.get("token");

  const togglePasswordVisibility = () => setShowPassword((prev) => !prev);

  const passwordChecks = {
    length: password.length >= 8,
    upper: /[A-Z]/.test(password),
    lower: /[a-z]/.test(password),
    number: /[0-9]/.test(password),
    symbol: /[^A-Za-z0-9]/.test(password),
  };

  const isPasswordStrong = Object.values(passwordChecks).every(Boolean);

  const renderCheck = (label, valid) => (
    <li style={{ color: valid ? "green" : "gray" }}>✔ {label}</li>
  );

  const handleSubmit = async (e) => {
    e.preventDefault();
    setMessage("");

    if (!isPasswordStrong) {
      setMessage("パスワードは要件をすべて満たしてください。");
      return;
    }

    if (password !== confirmPassword) {
      setMessage("パスワードが一致しません。");
      return;
    }

    setLoading(true);
    try {
      await api.post(
        `/api/auth/reset-password`,
        { token, password }
      );
      setMessage(
        "パスワードを変更しました<br/>5秒後にログイン画面に移動します"
      );
    } catch (err) {
      console.error(err);
      if (err.response) {
        setMessage(err.response.data?.message || "エラーが発生しました");
      } else {
        setMessage("通信エラーが発生しました");
      }
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (message.includes("パスワードを変更しました")) {
      const timer = setTimeout(() => {
        navigate("/login");
      }, 5000);
      return () => clearTimeout(timer);
    }
  }, [message, navigate]);

  return (
    <div style={{ maxWidth: 400, margin: "0 auto", padding: 20 }}>
      <h2>新しいパスワード設定</h2>
      <form onSubmit={handleSubmit}>
        <div style={{ marginBottom: 5, position: "relative" }}>
          <label>新しいパスワード</label>
          <input
            type={showPassword ? "text" : "password"}
            value={password}
            required
            onChange={(e) => setPassword(e.target.value)}
            style={{ width: "100%", padding: 8, marginTop: 4 }}
          />
          <span
            onClick={togglePasswordVisibility}
            style={{
              position: "absolute",
              right: 10,
              top: 35,
              cursor: "pointer",
              color: "#007bff",
              fontSize: 12,
            }}
          >
            {showPassword ? "非表示" : "表示"}
          </span>
        </div>

        <div style={{ fontSize: "12px", color: "#555", marginBottom: 5 }}>
          ※8文字以上で、大文字・小文字・数字・記号を含めてください。
        </div>
        <ul style={{ fontSize: "12px", marginTop: 0, marginBottom: 10, paddingLeft: 20 }}>
          {renderCheck("8文字以上", passwordChecks.length)}
          {renderCheck("大文字を含む（例：A）", passwordChecks.upper)}
          {renderCheck("小文字を含む（例：a）", passwordChecks.lower)}
          {renderCheck("数字を含む（例：1）", passwordChecks.number)}
          {renderCheck("記号を含む（例：!@#）", passwordChecks.symbol)}
        </ul>

        <div style={{ marginBottom: 16 }}>
          <label>新しいパスワード（確認）</label>
          <input
            type={showPassword ? "text" : "password"}
            value={confirmPassword}
            required
            onChange={(e) => setConfirmPassword(e.target.value)}
            style={{ width: "100%", padding: 8, marginTop: 4 }}
          />
        </div>

        <button
          type="submit"
          disabled={loading}
          style={{
            width: "100%",
            padding: "10px",
            background: "#28a745",
            color: "#fff",
            border: "none",
            cursor: "pointer",
          }}
        >
          {loading ? "変更中..." : "変更する"}
        </button>
      </form>
      {message && (
        <p
          style={{ marginTop: 10, color: "red" }}
          dangerouslySetInnerHTML={{ __html: message }}
        />
      )}
    </div>
  );
}